/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetSearchDriversByOrderIdAdminResponse } from '../models/GetSearchDriversByOrderIdAdminResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SearchDriversService {
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static acknowledgeSearchDriverDriver({
        searchDriverId,
    }: {
        searchDriverId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/searchdrivers/{searchDriverId}/acknowledge',
            path: {
                'searchDriverId': searchDriverId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewMonitoring`
     * @returns GetSearchDriversByOrderIdAdminResponse OK
     * @throws ApiError
     */
    public static getSearchDriversByOrderIdAdmin({
        orderId,
    }: {
        orderId: string,
    }): CancelablePromise<GetSearchDriversByOrderIdAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/searchdrivers/orders/{orderId}',
            path: {
                'orderId': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
